import { Fragment } from 'react';
import Tabs from '../Tabs/TabsComponent';
import DataSource from '../DataSource/DataSourceComponent';
import Separator from '../Separator/SeparatorComponent';
import InputEdit from '../InputEdit/InputEditComponent';
import CardRounded from '../CardRounded/CardRoundedComponent';
import __set from 'lodash/set';
import __get from 'lodash/get';
import __cloneDeep from 'lodash/cloneDeep';
import { removeBlankSpaces } from '../../utils/utils';

export default function AfegirBlocFormulariComponent({ editableInfo, newBlock, setNewBlock }) {
    const parsePath = (path) => {
        if (!path) return [];

        return path.split('.').flatMap((part) => {
            const match = part.match(/^([^\[]+)\[(\d+)\]$/);
            if (match) {
                return [match[1], Number(match[2])];
            }
            return part;
        });
    };

    const handleChange = (path, value, type) => {
        setNewBlock((prevState) => {
            const newValue = type === 'string' ? value : removeBlankSpaces(value);
            const newState = __cloneDeep(prevState);
            __set(newState, path, newValue);
            return newState;
        });
    };

    if (!editableInfo?.length) return null;

    return (
        <CardRounded height='100%'>
            <Tabs
                tabs={editableInfo.map((ei, index) => ({
                    id: `${index}`,
                    text: `Posició ${index + 1}`,
                    children: (
                        <>
                            <DataSource editableInfo={ei} blocConfig={{ propagateSource: newBlock?.props?.propagateSource }} />
                            {Object.keys(ei.editableProps || {}).map((key, index) => {
                                const field = ei.editableProps[key] || {};
                                const { type, desc, value: editablePropValue } = field;
                                const pathParts = key.split('.');
                                const basePath = [
                                    ...parsePath(ei.path).filter((p) => p !== undefined && p !== null),
                                    'props',
                                    ...pathParts
                                ];
                                const dataId = __get(newBlock, [
                                    ...parsePath(ei.path).filter((p) => p !== undefined && p !== null),
                                    'props',
                                    ...pathParts,
                                    'dataId'
                                ]);

                                const hasJsPath = __get(newBlock, [...basePath, 'jsPath']) !== undefined;
                                const valuePath = type === 'jspath' && hasJsPath ? [...basePath, 'jsPath'] : basePath;

                                const newBlockValue = __get(newBlock, valuePath);
                                const resolvedDesc =
                                    type === 'jspath' || desc === undefined
                                        ? `Provinent del camp ${key}${dataId ? ` de ${dataId}` : ''}`
                                        : typeof desc === 'string'
                                          ? desc
                                          : '';
                                return (
                                    <Fragment key={key}>
                                        <InputEdit
                                            label={key}
                                            value={newBlockValue ?? editablePropValue}
                                            type={type}
                                            desc={resolvedDesc}
                                            onChange={(e) => handleChange(valuePath, e.target.value, type)}
                                        />
                                        {index < Object.keys(ei.editableProps || {}).length - 1 && <Separator />}
                                    </Fragment>
                                );
                            })}
                        </>
                    )
                }))}
            />
        </CardRounded>
    );
}
